// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardit {
  background-image: none;
  --background: transparent;
}

.cardit ion-card-content {
  --background: transparent;
}

.moving-icon {
  position: relative;
  font-size: 50px;
}

ion-icon.moving {
  animation: moveIcon 2s infinite linear;
}

@keyframes moveIcon {
  0% {
    transform: translateX(0) rotate(0deg);
  }
  50% {
    transform: translateX(0px) rotate(360deg);
  }
  100% {
    transform: translateX(0) rotate(0deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/components/admin-box/admin-box.component.scss"],"names":[],"mappings":"AAAA;EAEE,sBAAA;EACA,yBAAA;AAAF;;AAGA;EAEE,yBAAA;AADF;;AAKA;EACE,kBAAA;EACA,eAAA;AAFF;;AAKA;EACE,sCAAA;AAFF;;AAKA;EACE;IACE,qCAAA;EAFF;EAIA;IACE,yCAAA;EAFF;EAIA;IACE,qCAAA;EAFF;AACF","sourcesContent":[".cardit {\n  //--background: #eaeaea;\n  background-image: none;\n  --background: transparent;\n}\n\n.cardit ion-card-content {\n  //--background: #eaeaea;\n  --background: transparent;\n}\n\n\n.moving-icon {\n  position: relative;\n  font-size: 50px;\n}\n\nion-icon.moving {\n  animation: moveIcon 2s infinite linear;\n}\n\n@keyframes moveIcon {\n  0% {\n    transform: translateX(0) rotate(0deg);\n  }\n  50% {\n    transform: translateX(0px) rotate(360deg);\n  }\n  100% {\n    transform: translateX(0) rotate(0deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
